export default "__VITE_ASSET__B4r9hv4F__"